import { Container, Row, Col, Tab, Nav } from "react-bootstrap";
import { ProjectCard } from "./ProjectCard";
import projImg1 from "../assets/img/project-img1.png";
import projImg2 from "../assets/img/project-img2.png";
import projImg3 from "../assets/img/project-img3.png";
import colorSharp2 from "../assets/img/color-sharp2.png";
import 'animate.css';
import TrackVisibility from 'react-on-screen';

export const Projects = () => {

  const projects = [
    {
      title: "Amazon Pet Chatbot",
      description: "LLM & RecSystem",
      imgUrl: projImg1,
      linkurl: "/article/amazon-pet-chatbot",
    },
    {
      title: "Walmart Hackathon",
      description: "Feature Eng & ML",
      imgUrl: projImg2,
      linkurl: "/article/walmart-hackathon",
    },
    {
      title: "Stock Prediction",
      description: "ML & NLP",
      imgUrl: projImg3,
      linkurl: "/article/Stock-Prediction",
    },
  ];

  const projectssecond = [
    {
      title: "Kuaishou Technology",
      imgUrl: projImg1,
      linkurl: "/article/Kuaishou-Technology",
    },
    {
      title: "DiDi Global Inc.",
      imgUrl: projImg2,
      linkurl: "/article/DiDi-Global-Inc",
    },
    {
      title: "Amazon",
      imgUrl: projImg3,
      linkurl: "/article/Amazon",
    },
  ];

  const projectsthird = [
    {
      title: "Big Data Analysis",
      imgUrl: projImg1,
      linkurl: "/article/Big-Data-Analysis",
    },
    {
      title: "Applied Machine Learning",
      imgUrl: projImg2,
      linkurl: "/article/Applied-Machine-Learning",
    },
    {
      title: "Recommendation System",
      imgUrl: projImg3,
      linkurl: "/article/Recommendation-System",
    },
  ];

  return (
    <section className="project" id="projects">
      <Container>
        <Row>
          <Col size={12}>
            <TrackVisibility>
              {({ isVisible }) =>
              <div className={isVisible ? "animate__animated animate__fadeIn": ""}>
                <h2>Projects</h2>
                <p>Here are some cool things I've built. Each project was a fun challenge, blending machine learning, deep learning, and real-world problem-solving. Check them out!</p>
                <Tab.Container id="projects-tabs" defaultActiveKey="first">
                  <Nav variant="pills" className="nav-pills mb-5 justify-content-center align-items-center" id="pills-tab">
                    <Nav.Item>
                      <Nav.Link eventKey="first">Featured</Nav.Link>
                    </Nav.Item>
                    <Nav.Item>
                      <Nav.Link eventKey="second">Internships</Nav.Link>
                    </Nav.Item>
                    <Nav.Item>
                      <Nav.Link eventKey="third">Academic</Nav.Link>
                    </Nav.Item>
                  </Nav>
                  <Tab.Content id="slideInUp" className={isVisible ? "animate__animated animate__slideInUp" : ""}>
                    <Tab.Pane eventKey="first">
                      <Row>
                        {
                          projects.map((project, index) => {
                            return (
                              <ProjectCard
                                key={index}
                                {...project}
                                />
                            )
                          })
                        }
                      </Row>
                    </Tab.Pane>
                    <Tab.Pane eventKey="second">
                      <Row>
                          {
                            projectssecond.map((project, index) => {
                              return (
                                <ProjectCard
                                  key={index}
                                  {...project}
                                  />
                              )
                            })
                          }
                        </Row>
                    </Tab.Pane>
                    <Tab.Pane eventKey="third">
                      <Row>
                          {
                            projectsthird.map((project, index) => {
                              return (
                                <ProjectCard
                                  key={index}
                                  {...project}
                                  />
                              )
                            })
                          }
                        </Row>
                    </Tab.Pane>
                  </Tab.Content>
                </Tab.Container>
              </div>}
            </TrackVisibility>
          </Col>
        </Row>
      </Container>
      <img className="background-image-right" src={colorSharp2}></img>
    </section>
  )
}
